function presentationCours() {
    return (
        <div>
            <h1>Mes cours:</h1>
            <div>Ut et fermentum neque. In quam orci, blandit a tincidunt id, consectetur in risus. Phasellus a sem nec
                lorem mattis accumsan. Donec pulvinar egestas purus, et interdum mi feugiat a. Curabitur vel blandit
                orci. Sed posuere, orci ut blandit finibus, massa arcu dapibus augue, nec fermentum justo tellus et
                nibh. Praesent a dui scelerisque, facilisis diam at, faucibus elit. Integer condimentum neque a dolor
                egestas, dignissim molestie quam blandit. Nulla ultrices, neque non sollicitudin auctor, enim diam
                maximus massa, vitae fringilla elit dui et lectus. Suspendisse nisi mauris, sollicitudin at lorem ac,
                ullamcorper placerat tortor. Donec mi arcu, aliquet in velit a, suscipit vehicula arcu.
            </div>
        </div>
    )
}

export default presentationCours